var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 28,
    viewBox: "0 0 32 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .prefix__cls-2{fill:#fd8c00}\n        "))), /*#__PURE__*/React.createElement("g", {
    id: "prefix__Flat",
    transform: "translate(.192 .168)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_1253",
    d: "M82.168 76.908c0-.146.1-.9 0-1l-8-8c-.1-.105.148 0 0 0h-13c-.147 0 .1-.1 0 0l-8 8c-.1.1 0-.147 0 0v8c0 .144-.1-.1 0 0l4 4c.1.108-.15 0 0 0h11l3 6c.1.149.818 0 1 0h8c.24 0 .925-.772 1-1l1-5c.018-.056 0 .058 0 0zm-10-1l9 1-5 4zm3 5h-6l2-5zm-7-1l-3-5h5zm-1 1h-6l3-5zm-7 0l-5-4 8-2zm8 1l-1 5-5-5zm1 0h5l-5 5zm12-4v8l-4-4zm-9-4l2-4 6 6zm-1 0h-7l-2-5h11zm-8 0l-8 2 6-6zm-4 7l-5 2v-5zm0 2l-2 4-3-3zm1-1l6 5h-8zm16 0l5 5h-11zm-7 6h11l-8 5zm11 5h-6l7-4z",
    "data-name": "Path 1253",
    transform: "translate(-51.359 -67.076)",
    style: {
      fill: "#ffd119"
    }
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "prefix__Group_1624",
    "data-name": "Group 1624"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_70",
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    className: "prefix__cls-2",
    "data-name": "Ellipse 70",
    transform: "translate(28.808 7.832)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_71",
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    className: "prefix__cls-2",
    "data-name": "Ellipse 71",
    transform: "translate(14.808 18.832)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "prefix__Ellipse_72",
    cx: 2,
    cy: 1.5,
    className: "prefix__cls-2",
    "data-name": "Ellipse 72",
    rx: 2,
    ry: 1.5,
    transform: "translate(17.808 24.832)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_73",
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    className: "prefix__cls-2",
    "data-name": "Ellipse 73",
    transform: "translate(26.808 24.832)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_74",
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    className: "prefix__cls-2",
    "data-name": "Ellipse 74",
    transform: "translate(28.808 18.832)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_75",
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    className: "prefix__cls-2",
    "data-name": "Ellipse 75",
    transform: "translate(14.808 12.832)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_76",
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    className: "prefix__cls-2",
    "data-name": "Ellipse 76",
    transform: "translate(7.808 -.168)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_77",
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    className: "prefix__cls-2",
    "data-name": "Ellipse 77",
    transform: "translate(20.808 -.168)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "prefix__Ellipse_78",
    cx: 2,
    cy: 1.5,
    className: "prefix__cls-2",
    "data-name": "Ellipse 78",
    rx: 2,
    ry: 1.5,
    transform: "translate(-.192 7.832)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "prefix__Ellipse_79",
    cx: 2,
    cy: 1.5,
    className: "prefix__cls-2",
    "data-name": "Ellipse 79",
    rx: 2,
    ry: 1.5,
    transform: "translate(-.192 14.832)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_80",
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    className: "prefix__cls-2",
    "data-name": "Ellipse 80",
    transform: "translate(3.808 18.832)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_81",
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    className: "prefix__cls-2",
    "data-name": "Ellipse 81",
    transform: "translate(10.808 6.832)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_82",
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    className: "prefix__cls-2",
    "data-name": "Ellipse 82",
    transform: "translate(17.808 6.832)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "prefix__Ellipse_83",
    cx: 2,
    cy: 1.5,
    className: "prefix__cls-2",
    "data-name": "Ellipse 83",
    rx: 2,
    ry: 1.5,
    transform: "translate(6.808 12.832)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_84",
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    className: "prefix__cls-2",
    "data-name": "Ellipse 84",
    transform: "translate(22.808 12.832)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAi);
export default __webpack_public_path__ + "static/media/ai.d5522a6827d01652963a15126c6d5bcf.svg";
export { ForwardRef as ReactComponent };